export default __webpack_public_path__ + "static/media/Punto_10_Chiesa_degli_Olandesi_DEU_Def.5eb3ab4d.aac";